module.exports = __webpack_public_path__ + "static/media/ana-lucena-2.c2fe508f.jpeg";